export async function openAddDataDialog() {
  const { displayAddDataDialog } = await import(
    /* webpackChunkName: "add-data-hub-dialog" */ 'cadenza/workbook/workbook-panel/databrowser/add-data-hub-dialog'
  );
  return displayAddDataDialog();
}
